import FootballStatsCategory from "../../../stats/football-stats-category";
import DriveService from "../../../../../services/drive-service";
import FootballState from "../../../state/football-state";
import StatsRule from "../../../../common/stats-rule";

export default class PatDefenseCompleteStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const statsFragment =
            play.getFirstFragment(FootballState.PatKick) ||
            play.getFirstFragment(FootballState.PatPass) ||
            play.getFirstFragment(FootballState.Run);
        const { defensivePAT: points } = gameContext.gameConfig.scoring || {
            defensivePAT: 0
        };

        const teamId = play.contextSnapshot.homeTeamHasPossession
            ? gameContext.awayTeamId
            : gameContext.homeTeamId;

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: teamId,
            playerId: null,
            driveId: await DriveService.resolveDriveId(play, gameContext),
            fragmentId: statsFragment.id,
            category: FootballStatsCategory.PAT_COMPLETE,
            values: { points }
        });
    }

    switchPossession() {}
}
